// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"23dc5952","866":"56c4ca78"}[chunkId] + ".chunk.js";
};